import { render, staticRenderFns } from "./EditMedicalFile.vue?vue&type=template&id=710b17ad&scoped=true"
import script from "./EditMedicalFile.vue?vue&type=script&lang=js"
export * from "./EditMedicalFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710b17ad",
  null
  
)

export default component.exports